import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  initialize() {
    const autobidProgressBar = document.getElementById('autobidProgressBar');
    if (autobidProgressBar)
      autobidProgressBar.style.width = '100%';

    const autobidTimeout = setTimeout(() => {
      window.location.href = `${window.location.href}?skip_progressbar=1`;
    }, 25000);

    const autobidCheck = setInterval(() => {
      fetch(this.data.get('statusUrl')).then(response => {
        if (response.status !== 200) return;

        if (autobidProgressBar) {
          autobidProgressBar.style.transition = 'width 1s ease';
          autobidProgressBar.style.width = '99.9%';
        }

        clearInterval(autobidCheck);
        clearTimeout(autobidTimeout);

        setTimeout(() => {
          window.location.reload();
        }, 500);
      });
    }, 3000);
  }
}
